import { PassouFalhouEnum } from '@mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { isEmpty } from 'bold-ui'
import { SimNaoEnum } from 'components/form'

import { ConsultaSeguimentoPergunta13Model } from './model-consultaSeguimentoPergunta13'

export function prunePergunta13(value: ConsultaSeguimentoPergunta13Model): ConsultaSeguimentoPergunta13Model {
  const pruned: ConsultaSeguimentoPergunta13Model = {
    status: value.status,
    resultado: value.resultado,
    PERGUNTA_13_HEADER: value.PERGUNTA_13_HEADER,
  }

  if (value.PERGUNTA_13_HEADER === SimNaoEnum.SIM) {
    pruned.PERGUNTA_13_ANDA_SEM_APOIO = value.PERGUNTA_13_ANDA_SEM_APOIO
  }

  return pruned
}

export function conditionToCalculatePergunta13(values: ConsultaSeguimentoPergunta13Model): boolean {
  if (values?.PERGUNTA_13_HEADER === SimNaoEnum.NAO || !isEmpty(values?.PERGUNTA_13_ANDA_SEM_APOIO)) {
    return true
  }
  return false
}

export function calculateResultadoPergunta13(values: ConsultaSeguimentoPergunta13Model): PassouFalhouEnum | undefined {
  if (values?.PERGUNTA_13_HEADER === SimNaoEnum.NAO || values?.PERGUNTA_13_ANDA_SEM_APOIO === SimNaoEnum.NAO) {
    return PassouFalhouEnum.FALHOU
  } else if (values?.PERGUNTA_13_ANDA_SEM_APOIO === SimNaoEnum.SIM) {
    return PassouFalhouEnum.PASSOU
  }
}
